/**
 * Décalages verticaux du viewer 3D (desktop).
 * Valeurs négatives = remontée dans la marge au-dessus du conteneur.
 * Réduits pour rapprocher le canvas du message « Vous pourrez… » et
 * limiter la coupure en haut sur les caches de grande hauteur.
 */
export const VIEWER_TOP_OFFSET_PX = -50;

/** Décalage additionnel du seul canvas (badges / partage restent plus bas). */
export const VIEWER_CANVAS_TOP_OFFSET_PX = -55;

/** Distance au bas du conteneur pour « Fabriqué en France » + partage. */
export const VIEWER_OVERLAY_BOTTOM_PX = { xs: 52, md: 32 };
